import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfirmationService, Message, SelectItem } from 'primeng/api';
import { ZonaBarrio } from '../../_models/zona-barrio';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NavService } from '../../_services/_nav.service';
import { ListaService } from '../../_services/lista.service';
import { ZonaService } from '../../_services/zona.service';
import { DivisionPoliticaService } from '../../_services/division-politica.service';
import { ZonaBarrioService } from '../../_services/zona-barrio.service';
import { forkJoin, of } from 'rxjs';
import { Zona } from '../../_models/zona';
import { AgendasService } from '../../_services/agendas.service';
import { Agenda } from '../../_models/agenda';
import { TerceroZonaService } from '../../_services/tercero-zona.service';
import { TerceroZona } from '../../_models/tercero-zona';
import { ModalidadService } from '../../_services/modalidad.service';
import { Modalidad } from '../../_models/modalidad';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { sleep } from '../../../app/utils/utilidades';
import { ZonaModalidadesService } from '../../_services/zona-modalidades.service';
import { ZonaModalidad } from '../../_models/zona-modalidad';

@Component({
  selector: 'app-zonas-editar',
  templateUrl: 'zonas-form.component.html',
})

export class ZonasEditarComponent implements OnInit {

  msgs: Message;
  @Input() zone: Zona = new Zona();
  @Input() idEstructuraFisica: string;
  @Output() cerrar: EventEmitter<boolean> = new EventEmitter();
  barrios: ZonaBarrio[] = [];
  clasificationZone: SelectItem[] = [];
  paises: SelectItem[] = [];
  departamentos: SelectItem[] = [];
  municipios: SelectItem[] = [];
  idPais: string = null;
  idDepartamento: string = null;
  idMunicipio: string = null;
  barriosDisponibles: any[] = [];
  barriosSeleccionados: any[] = [];
  codeExists = false;
  edit = true;
  barriosZone: ZonaBarrio[] = [];
  barrioZone: ZonaBarrio;
  result: number;
  existsBarrios = true;
  clasificacionActual: any;
  cargando = true;
  carInformacionInicial = true;
  guardando = false;
  guaBarrios = false;
  zones: Zona[] = [];
  tabSeleccionado = 'INFO';
  ageZonas: Agenda[] = [];
  terZonas: TerceroZona[] = [];
  listadoModalidadesTodos: Modalidad[] = [];
  lisModalidades: SelectItem[] = [];
  lisModalidadAgregar: ZonaModalidad[] = [];
  lisModalidadPorZona: ZonaModalidad[] = [];
  submitted = false;
  submittedModalidad = false;
  formulario: FormGroup;
  columnas: any[];
  requeridoAdd = false;
  validandoModalidad = false;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private navService: NavService,
    private formBuilder: FormBuilder,
    private listaService: ListaService,
    private confirmationService: ConfirmationService,
    private zonesService: ZonaService,
    private ageServicio: AgendasService,
    private terZonaServicio: TerceroZonaService,
    private divisionPoliticaService: DivisionPoliticaService,
    private zonesBarriosService: ZonaBarrioService,
    private modalidadService: ModalidadService,
    private zonasModalidadesService: ZonaModalidadesService,
    private conServicio: ConfirmationService,
    private nav: NavService, ) {


  }

  ngOnInit() {
    // this.route.params.subscribe( ( params: Params ) => {
    this.setearColumnas();
    this.cargarFormulario();
    if (this.zone && this.zone.idZona !== null && this.zone.idZona !== '' && this.zone.idZona !== undefined) {
      forkJoin(
        this.zonesBarriosService.getAllByZona(this.zone.idZona),
        this.ageServicio.obtenerPorZona(this.zone.idZona),
        this.terZonaServicio.obtenerPorZonas(this.zone.idZona),
        // this.zonesService.get( +params[ 'id' ] )
      ).subscribe(([data, agendas, terZonas]) => {
        // this.zone = zona;
        this.terZonas = terZonas;
        this.ageZonas = agendas.filter(x => x.indicadorHabilitado);
        this.clasificacionActual = this.zone.idClasificacionZona;
        data.map((s: any) => {
          if (s.indicadorHabilitado) {
            this.barriosSeleccionados.push(s);
          }
          this.barrios.push(s);
        });
        if (this.barriosSeleccionados.length === 0) {
          this.existsBarrios = false;
        }
        this.cargarServicios();
      });
    } else {
      this.existsBarrios = false;
      this.zonesService.getAll().subscribe(lisZonas => {
        this.zones = lisZonas;
        this.cargarServicios();
      });
    }

    // } );
  }

  /* columnas del data table */
  setearColumnas() {
    this.columnas = [
      {
        field: "nombreModalidad",
        header: this.navService.buscarMensaje(
          "ZONES.LBL_MODALIDAD"
        ),
        sort: true,
      },
      {
        field: "acciones",
        header: this.navService.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
  }

  /* incializar el formulario */
  cargarFormulario() {
    this.formulario = this.formBuilder.group({
      idZona: [this.zone ? this.zone.idZona : null],
      codigoZona: [this.zone ? this.zone.codigo : null, [Validators.required]],
      nombreZona: [this.zone ? this.zone.nombre : null, [Validators.required]],
      idClasificacionZona: [this.zone ? this.zone.idClasificacionZona : null, [Validators.required]],
      descripcionZona: [this.zone ? this.zone.descripcion : null, [Validators.required]],
      idsModalidad: [null],
      indicadorHabilitado: [this.zone ? this.zone.indicadorHabilitado : false],
      indicadorZonaLibre: [this.zone ? this.zone.indicadorZonaLibre : false],
      homologacionUsuario: [this.zone ? this.zone.homologacionUsuario : null]
    });
  }

  async agregarModalidad() {
    if (this.formulario.value.idsModalidad !== null && this.formulario.value.idsModalidad.length > 0) {
      let mensaje = '';
      this.requeridoAdd = false;
      this.validandoModalidad = true;
      await Promise.all(this.formulario.value.idsModalidad.map(async (idModalidad) => {
        if (this.zone && this.zone.idZona) {
          const sepuedeagregar = await this.zonasModalidadesService.validarAgregarModalidad(idModalidad, this.zone.idZona).toPromise();
          const modalidadAdd = this.listadoModalidadesTodos.find((x) => x.idModalidad === idModalidad);
          if (modalidadAdd && sepuedeagregar) {
            const zonaModalidadAdd = {} as ZonaModalidad;
            zonaModalidadAdd.idModalidad = modalidadAdd.idModalidad;
            zonaModalidadAdd.idZona = this.zone.idZona;
            zonaModalidadAdd.modalidad = modalidadAdd.nombre;
            zonaModalidadAdd.indicadorHabilitado = true;
            this.lisModalidadAgregar.push(zonaModalidadAdd);
            if (this.lisModalidadPorZona.find((x) => x.idModalidad === idModalidad)) {
              this.lisModalidadPorZona.find((x) => x.idModalidad === idModalidad).indicadorHabilitado = true;
            } else {
              this.lisModalidadPorZona.push(zonaModalidadAdd);
            }
          } else {
            mensaje += '{' + modalidadAdd.nombre + '}';
          }
        } else {
          const modalidadAdd = this.listadoModalidadesTodos.find((x) => x.idModalidad === idModalidad);
          if (modalidadAdd) {
            const zonaModalidadAdd = {} as ZonaModalidad;
            zonaModalidadAdd.idModalidad = modalidadAdd.idModalidad;
            zonaModalidadAdd.modalidad = modalidadAdd.nombre;
            zonaModalidadAdd.indicadorHabilitado = true;
            this.lisModalidadAgregar.push(zonaModalidadAdd);
            this.lisModalidadPorZona.push(zonaModalidadAdd);
          }
        }
      }));
      this.f.idsModalidad.setValue(null);
      this.lisModalidades = [];
      this.listadoModalidadesTodos.map((x) => {
        if (!this.lisModalidadAgregar.find((value) => value.idModalidad === x.idModalidad)) {
          this.lisModalidades.push({
            label: x.nombre,
            value: x.idModalidad,
          });
        }
      });
      this.validandoModalidad = false;
      if (mensaje.length > 0) {
        this.conServicio.confirm({
          message: 'No se pudieron agregar las siguientes modalidades ' + mensaje +
          ' porque ya se encuentran en otra zona con los mismos barrios',
          header: this.nav.buscarMensaje('LBL_CONFIRMACION'),
          icon: 'fa fa-question-circle',
          key: 'zon-agregar',
          accept: () => {
            this.guardando = false;
          },
        });
      }
    } else {
      this.requeridoAdd = true;
    }
  }

  eliminar(modalidad: any) {
    console.log(modalidad);
    const modalidadEliminar = this.lisModalidadAgregar.find((x) => x.idModalidad === modalidad.idModalidad);
    for (let i = 0; i < this.lisModalidadAgregar.length; i++) {
      if (this.lisModalidadAgregar[i].idModalidad === modalidadEliminar.idModalidad) {
        if (this.lisModalidadAgregar[i].idZonaModalidad) {
          this.lisModalidadPorZona.find(
            (x) => x.idZonaModalidad === this.lisModalidadAgregar[i].idZonaModalidad).indicadorHabilitado = false;
        }
        this.lisModalidadAgregar.splice(i, 1);
      }
      if (this.lisModalidadPorZona[i].idModalidad === modalidadEliminar.idModalidad && !this.lisModalidadPorZona[i].idZonaModalidad) {
        this.lisModalidadPorZona.splice(i, 1);
      }
    }
    this.lisModalidades.push({
      label: modalidad.modalidad,
      value: modalidad.idModalidad,
    });
  }

  cargarServicios() {
    forkJoin(
      this.listaService.getMasterDetails('ListasClasificacionesZonas'),
      this.divisionPoliticaService.obtenerConHijos('0'),
      this.modalidadService.listadoModalidadesHabilitadas()
    ).subscribe(async ([res, res2, lisModalidades]) => {
      this.listadoModalidadesTodos = lisModalidades;
      this.listadoModalidadesTodos.map((x) => {
        this.lisModalidades.push({
          label: x.nombre,
          value: x.idModalidad,
        });
      });
      if (this.zone && this.zone.idZona) {
        this.lisModalidadPorZona = await this.zonasModalidadesService.obtenerAllPorIdZonaTodos(this.zone.idZona).toPromise();
        this.lisModalidadPorZona.map((modalidad) => {
          if (modalidad.indicadorHabilitado === true) {
            this.lisModalidadAgregar.push(modalidad);
          }
        });
        this.lisModalidades = [];
        this.listadoModalidadesTodos.map((x) => {
          if (!this.lisModalidadAgregar.find((value) => value.idModalidad === x.idModalidad)) {
            this.lisModalidades.push({
              label: x.nombre,
              value: x.idModalidad,
            });
          }
        });
      }
      res.map((s: any) => {
        this.clasificationZone.push({ label: s.nombre, value: s.idLista });
      });

      res2.map((s: any) => {
        this.paises.push({ label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica });
      });
      this.carInformacionInicial = false;
      this.cargando = false;
    });
  }

  goBack(fDirty: boolean): void {
    if (fDirty) {
      this.confirmationService.confirm({
        message: this.navService.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navService.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        key: 'zon-editar',
        accept: () => {
          // this.router.navigate( [ 'apl/zonas/' ] );
          this.cerrar.emit(false);
        }
      });
    } else {
      // this.router.navigate( [ 'apl/zonas/' ] );
      this.cerrar.emit(false);
    }
  }

  changePais(event: any) {
    this.municipios = [];
    this.departamentos = [];
    this.barriosDisponibles = [];
    this.divisionPoliticaService.obtenerConHijos(event).subscribe(res => {
      res.map((s: any) => {
        this.departamentos.push({ label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica });
      });
    });
  }

  changeDepartamento(event: any) {
    this.municipios = [];
    this.barriosDisponibles = [];
    this.divisionPoliticaService.obtenerConHijos(event).subscribe(res => {
      res.map((s: any) => {
        this.municipios.push({ label: s.descripcionDivisonPolitica, value: s.idDivisionPolitica });
      });
    });
  }

  changeMunicipio(event: any) {
    this.barriosDisponibles = [];
    this.cargando = true;
    this.zonesBarriosService.getAllByBarrio(this.zone.idClasificacionZona, event, this.zone.idZona).subscribe(res => {
      this.barriosDisponibles = res;
      if (this.barriosDisponibles.length === 0) {
        this.navService.setMesage(0, {
          severity: 'info', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
          detail: this.navService.buscarMensaje('ZONES.MSG_NOEXISTENBARRIOSDISPONIBLES')
        });
      }
      this.cargando = false;
    });

  }

  async onSubmit() {
    this.submitted = true;
    if (this.formulario.valid && this.lisModalidadAgregar.length > 0) {
      this.guardando = true;
      if (this.zone.idZona !== null && this.zone.idZona !== '' && this.zone.idZona !== undefined) {
        const formulario = this.formulario.getRawValue();
        this.zone.codigo = formulario.codigoZona;
        this.zone.idClasificacionZona = formulario.idClasificacionZona;
        this.zone.descripcion = formulario.descripcionZona;
        this.zone.homologacionUsuario = formulario.homologacionUsuario;
        this.zone.indicadorZonaLibre = formulario.indicadorZonaLibre;
        this.zone.indicadorHabilitado = formulario.indicadorHabilitado;
        this.zone.nombre = formulario.nombreZona;
        if (!this.zone.indicadorZonaLibre) {
          this.zone.homologacionUsuario = null;
        }
        this.zonesService.get(this.zone.idZona).subscribe(async (response) => {
          if (response && response.indicadorDescargado !== null && response.indicadorDescargado === true) {
            this.navService.setMesage(0, {
              severity: 'info', summary: this.navService.buscarMensaje('LBL_ADVERTENCIA'),
              detail: this.navService.buscarMensaje('ZONES.MSG_ERROREDITARZONA')
            });
            this.guardando = false;
          } else {
            if (this.zone.indicadorHabilitado || !this.barrios.find( x => x.indicadorHabilitado)) {
              this.zonesService.update(this.zone).subscribe(res => {
                if (res && res.idZona) {
                  this.guardarZonaModalidades(res.idZona);
                }
                if (!this.zone.indicadorHabilitado && this.terZonas.length > 0) {
                  this.terZonas.map((s: TerceroZona) => {
                    s.indicadorHabilitado = false;
                  });
                  this.terZonaServicio.bulk(this.terZonas).subscribe(zonas => {
                    this.terZonas = [];
                    this.clasificacionActual = this.zone.idClasificacionZona;
                    this.navService.setMesage(2);
                    this.guardando = false;
                    this.tabSeleccionado = 'BARRIO';
                  });
                } else {
                  this.clasificacionActual = this.zone.idClasificacionZona;
                  this.navService.setMesage(2);
                  this.guardando = false;
                  this.tabSeleccionado = 'BARRIO';
                }
              }, error => {
                // 1 = Add, 2 = Update, 3 Error, 4 Custom
                this.navService.setMesage(3);
                this.guardando = false;
              });
            } else {
              this.guardando = false;
              this.navService.setMesage(0, {
                severity: 'info', summary: this.navService.buscarMensaje('LBL_INFORMACION'),
                detail: this.navService.buscarMensaje('ZONES.MSG_NOPUEDEDESHABILITAR')
              });
            }
          }
        });
      } else {
        const formulario = this.formulario.getRawValue();
        this.zone.codigo = formulario.codigoZona;
        this.zone.idClasificacionZona = formulario.idClasificacionZona;
        this.zone.descripcion = formulario.descripcionZona;
        this.zone.homologacionUsuario = formulario.homologacionUsuario;
        this.zone.indicadorZonaLibre = formulario.indicadorZonaLibre;
        this.zone.indicadorHabilitado = formulario.indicadorHabilitado;
        this.zone.nombre = formulario.nombreZona;
        this.zone.idEstructuraFisica = this.idEstructuraFisica;
        this.zonesService.add(this.zone).subscribe(async res => {
          this.zone.idZona = res.idZona;
          this.guardarZonaModalidades(this.zone.idZona);
          this.clasificacionActual = this.zone.idClasificacionZona;
          this.navService.setMesage(1);
          this.guardando = false;
          this.tabSeleccionado = 'BARRIO';
        }, error => {
          // 1 = Add, 2 = Update, 3 Error, 4 Custom
          this.navService.setMesage(3);
          this.guardando = false;
        });
      }
    }
  }

  async guardarZonaModalidades(idZona: string) {
    this.lisModalidadPorZona.map((value) => {
      value.idZona = idZona;
    });
    await this.zonasModalidadesService.bulk(this.lisModalidadPorZona).toPromise();
  }

  onSubmitBarrios() {
    this.guaBarrios = true;

    setTimeout ( () => {
      if (this.clasificacionActual === this.zone.idClasificacionZona) {
        this.guaBarrios = true;
        const barriosInhabilitar = this.barrios.filter(
          item => item.indicadorHabilitado && this.barriosSeleccionados.filter(
            item2 => (item2.idBarrio === item.idBarrio) ||
              (item2.idDivisionPolitica === item.idBarrio)).length === 0);

        const barriosAdicionar = this.barriosSeleccionados.filter(
          item => this.barrios.filter(
            item2 => (item2.idBarrio === item.idBarrio) || (item2.idBarrio === item.idDivisionPolitica)).length === 0);

        let barriosHabilitar = this.barrios.filter(
          item => !item.indicadorHabilitado && this.barriosSeleccionados.filter(
            item2 => (item2.idBarrio === item.idBarrio) ||
              (item2.idDivisionPolitica === item.idBarrio)).length > 0);

        barriosHabilitar.sort(function (a, b) {
          return b.id - a.id;
        });

        const arraySave = barriosHabilitar.reduce(function (p, c) {
          if (!p.some(function (el) { return el.idBarrio === c.idBarrio; })) p.push(c);
          return p;
        }, []);

        barriosHabilitar = arraySave.length > 0 ? arraySave : barriosHabilitar;

        this.barriosZone = [];
        let ageInhabilitar = [];
        for (let i = 0; i < barriosInhabilitar.length; i++) {
          barriosInhabilitar[i].indicadorHabilitado = false;
          this.barriosZone.push(barriosInhabilitar[i]);
          const a = this.ageZonas.filter(x => x.idZonaBarrio === barriosInhabilitar[i].idZonaBarrio);
          if (a.length > 0) {
            a.map((s: Agenda) => {
              s.indicadorHabilitado = false;
            });
            ageInhabilitar = ageInhabilitar.concat(a);
          }
        }

        for (let i = 0; i < barriosHabilitar.length; i++) {
          barriosHabilitar[i].indicadorHabilitado = true;
          this.barriosZone.push(barriosHabilitar[i]);
        }

        for (let i = 0; i < barriosAdicionar.length; i++) {
          this.barrioZone = new ZonaBarrio();
          this.barrioZone.indicadorHabilitado = true;
          this.barrioZone.idBarrio = barriosAdicionar[i].idDivisionPolitica;
          this.barrioZone.idZona = this.zone.idZona;
          this.barriosZone.push(this.barrioZone);
        }

        if (this.barriosZone.length > 0) {
          this.zonesBarriosService.updateBulk(this.barriosZone).subscribe(data => {
            if (ageInhabilitar.length > 0) {
              this.ageServicio.bulk(ageInhabilitar).subscribe(age => {
                this.navService.setMesage(2);
                this.guaBarrios = false;
                // this.router.navigate( [ 'apl/zonas/' ] );
                this.cerrar.emit(true);
              });
            } else {
              this.navService.setMesage(2);
              this.guaBarrios = false;
              // this.router.navigate( [ 'apl/zonas/' ] );
              this.cerrar.emit(true);
            }
          }, error => {
            this.navService.setMesage(3);
            this.guaBarrios = false;
            // this.router.navigate( [ 'apl/zonas/' ] );
            this.cerrar.emit(true);
          });
        } else {
          this.navService.setMesage(2);
          this.guaBarrios = false;
          // this.router.navigate( [ 'apl/zonas/' ] );
          this.cerrar.emit(true);
        }

      } else {
        this.navService.setMesage(0, {
          severity: 'info', summary: 'Info', detail: this.navService.buscarMensaje('ZONES.MSG_CLASIFICACIONZONA')
        });
        this.barriosSeleccionados = [];
        if (this.idMunicipio !== null && this.idMunicipio !== undefined) {
          this.changeMunicipio(this.idMunicipio);
        }

      }
    }, 500 );
  }

  validateCode() {
    this.codeExists = this.zones.filter(
      t => (t.codigo === this.zone.codigo &&
        t.idZona !== this.zone.idZona)).length > 0;
  }

  abrirAcordeon(evento: any) {
    switch (evento.index) {
      case 0: {
        this.tabSeleccionado = 'INFO';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'BARRIO';
        break;
      }
      default: {
        break;
      }
    }
  }

  get f() {
    return this.formulario.controls;
  }
}
